<template>
    <div>
        <div class="pro-setting">
            <Loading v-if="is_all_loading || is_loading" />
            <div class="head">
                <div class="left">
                    <i @click="onlyClose"><svg-icon name="close" /></i>
                    {{ get_data.application_title }}
                </div>
                <div class="right">
                    <div class="desc">Updated 2 min ago</div>
                    <Button class="pre-btn" :border_r="6" size="32" @click.native="onlyView" :flex="true"> <svg-icon
                            name="eye" />Preview </Button>
                    <Button :border_r="6" color="white" size="32" @click.native="saveCallInside()" :is_disabled="!is_can_save">Save changes</Button>
                    <Button class="del-btn" :border_r="6" size="32" @click.native="is_show_del_modal=true" :flex="true" v-if="application_status==='draft'">Delete</Button>
                    <Button :border_r="6" color="white" size="32" @click.native="publish()" :is_disabled="!(application_status === 'draft' || application_status === 'closed' || has_unpublished_changes===1 ||is_can_save || (!call_api_btn.publish && call_api_btn.is_change))">{{ application_status==='closed'? `Republish`:`Publish`}}</Button> 
                </div>
            </div>

            <!-- edit setting saveing put in ProgramForm  -->
            <div class="pro-setting-box" v-if="!is_all_loading && !is_loading">
                
                <div class="left-template">
                    <ProgramForm ref="formLeft" :data="data" :type="type" :is_edit_setting="type==='create' || type==='edit'" 
                        :only_view="is_only_for_view" :porgram_for_who="porgram_for_who" :is_copy="is_copy" :key_refrash_left="key_refrash_left" :key_refrash_left_country="key_refrash_left_country"
                        @close_only_view="closeOnlyForView" @update-data="updateLeft" @save-form="saveAllSetting" :is_first_create="is_first_create" @handle_old_data="handleOldData" :is_can_save ="is_can_save"/>
                </div>
                <div class="right-template">
                    <FormFormRight :data="data" :type="type" @update-data="updateRight"
                        :is_show_all="true"
                        :ambassador_application_id="porgram_id"
                        :ambassador_application_name="data.basic[0].question[0].client_view.val"
                        :application_status="application_status"
                        :is_edit="type === 'edit'"
                        :title="data.settings[0].section_groups[0].group_setting[0].input_value"
                        :key="key_refrash_right" />
                </div>
            </div>
        </div>

        <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal=false;is_click_window=false;">
            <div class="box">
                <header class="delete-header">Save changes?</header>
                <p>Any unsaved changes will be permanently removed.</p>
                <div class="btns">
                    <Button type="button" :border_r="6" color="white" size="32"
                        @click.native="is_click_window=false;openClose();">Discard</Button>
                    <Button type="button" :border_r="6" color="dark-blue" size="32" @click.native="saveCallInside(); will_close_setting=true;">Save &
                        exit</Button>
                </div>
            </div>
        </Modal>

        <Modal :is_show="is_show_save_modal" class="alert-modal" @click-bg="is_show_save_modal=false">
            <div class="box">
                <header class="delete-header">{{ type==='create'? 'Create':'Update' }} application?</header>
                <p>Changes to your settings will be reflected with future applicants and will not affect any prior applicants.</p>
                <div class="btns">
                    <Button type="button" :border_r="6" color="white" size="32"
                        @click.native="is_show_save_modal=false">No</Button>
                    <Button type="button" :border_r="6" color="dark-blue" size="32" @click.native="saveCallInside();is_show_save_modal=false;">Confirm</Button>
                </div>
            </div>
        </Modal>

        <Modal :is_show="is_show_del_modal" class="alert-modal" @click-bg="is_show_del_modal = false">
            <div class="box">
                <header class="delete-header">Delete application?</header>
                <!-- <p>You will lose access to all candidate information and responses if you choose to delete this application. You can stop accepting submissions in your Applications dashboard.</p> -->
                <div class="btns">
                    <Button type="button" :border_r="6" color="white" size="32"
                        @click.native="is_show_del_modal = false">Don't delete</Button>
                    <Button class="modal-del-btn" type="button" :border_r="6" color="dark-blue" size="32" @click.native="delPro()">Delete</Button>
                </div>
            </div>
        </Modal>

        <Modal :is_show="is_show_unp_modal" class="un-pub-modal" @click-bg="is_show_unp_modal = false">
            <div class="box">
                <header class="delete-header">Submission error</header>
                <div>Please review and complete the required field(s): <br />
                    <ul>
                        <li v-for="(v,k) in err_box" :key="k">{{ v }}</li>
                    </ul>
                </div>
                <div class="btns">
                    <Button type="button" :border_r="6" color="dark-blue" size="32" @click.native="is_show_unp_modal = false">OK</Button>
                </div>
            </div>
        </Modal>

        <ApplicationPublishModal :url="url_link" ref="pub_modal" />

        <!-- <Modal :is_show="is_show_pub_modal" class="un-pub-modal un-pub-modal-2" @click-bg="is_show_pub_modal = false">
            <div class="big-header">
                <svg-icon class="close-svg" name="close" @click="is_show_pub_modal=false"/>
            </div>
            <div class="box">
                <svg-icon class="header-svg" name="yes"/>
                <header class="delete-header">Your application is now live!</header>
                <p>Share this link to begin receiving submissions.</p>
                <div class="share-popup-menu--body" @click="copy(url_link)">
                    <span class="link"> {{ url_link }}</span>
                    <span class="btn">Copy</span>
                </div>
                <div class="btns">
                    <Button type="button" :border_r="6" color="white" size="40"
                        @click.native="is_show_pub_modal=false">Done</Button>
                    <Button type="button" :border_r="6" color="dark-blue" size="40" @click.native="goView(url_link)">View application</Button>
                </div>
            </div>
        </Modal> -->
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import ProgramForm from '@/components/programs/Form/ProgramForm.vue';
import FormFormRight from '@/components/programs/Form/FormFormRight.vue';
import Loading from '@/components/ui/Loading.vue';
import Modal from '@/components/ui/Modal.vue';
// import copyToClipboard from 'copy-to-clipboard';
import ApplicationPublishModal from '@/components/programs/ApplicationPublishModal.vue';
import { FormList, FormSetting, OtherFormSetting, getIndex, getFormApiData,HandleErrFunction,checkBasic,checkSocial } from '@/utils/ProgramsData.js';
export default {
    name: 'Form-Setting',

    data() {
        return {
            is_loading:false,
            type:'create',
            is_copy:false,
            get_form_data_api:'',
            data_old:FormSetting,//存取改動前的資料
            data: FormSetting,
            porgram_for_who:1,
            porgram_id:null,
            application_status:'draft',//預設草稿，如果有拿到資料或存過檔才可能會改動
            //儲存分一般儲存跟發布儲存,未更動前是禁止儲存跟發布，但更動後皆可以執行，
            //儲存過後會重新拿資料，又變成不能存檔的狀態，但發布因為還沒有發布，所以是可以發布的，但發布後會一起儲存，所以影響的主要是先儲存但還沒執行發布
            call_api_btn:{
                publish:false,
                is_change:false,
            },
            has_unpublished_changes:0,//如果只有執行存檔沒有發布，會是1(後端會給這值)
            is_click_publish:false,
            get_data: {
                application_title:'',
            },
            is_all_loading: true,
            is_show_alert_modal: false,
            from_list_handle_for_view:false,
            is_only_for_view: false,
            key_refrash_left:0,
            key_refrash_left_country:0,
            key_refrash_right:0,
            will_close_setting:false,
            is_save_call_in:false,
            is_first_create:false,
            is_show_del_modal:false,
            is_show_save_modal:false,
            is_show_unp_modal:false,
            // is_show_pub_modal:false,
            err_box:[],
            get_old_data:{
                old:null,
                new:null,
            },
            //handle住重整或上一頁的
            is_click_window:false,
            is_saving:false,//回上一頁只能手動關閉的紀錄，因為會攔截上一頁的動作，所以JS的也被攔截，這邊要記錄是JS的上一頁
            resolveLeave: null, // 存resolve
            pendingNavigation: null, // 保存準備執行的路由
            originalURL: null, // 保存原始的 URL
            is_leave:false,//重整看的，避免往上一頁跳出彈出視窗
            is_key_ref:false,//鍵盤重整時，會跳出是否存檔，這邊要記住是重整，避免自動回上一頁
            
        }
    },

    computed: {
        head_right_desc(){
            if(this.type==='create'){
                return 'Draft saved - unpublish'
            }
        },

        url_link (){
            let url = !this.$store.state.user_data ? '': this.$store.state.user_data ? this.$store.state.user_data.merchant_account.anchor_ambassador_subdomain: `${this.$store.state.user_data.merchant_account.merchant_display_name}.anchor.store`
            let baUrl=this.data.settings && this.data.settings[0]? this.data.settings[0].section_groups[0].group_setting[1].input_value:'';
            return `${url}/p/${baUrl}`
        },

        is_can_save() {
            // check data is change
            // &&
            // JSON.stringify(this.data.basic) === JSON.stringify(this.get_old_data.handle_data.basic)&&
            // JSON.stringify(this.data.custom_question) === JSON.stringify(this.get_old_data.handle_data.custom_question)&&
            // JSON.stringify(this.data.parent_guardian_consent) === JSON.stringify(this.get_old_data.handle_data.parent_guardian_consent)&&
            // JSON.stringify(this.data.social_account) === JSON.stringify(this.get_old_data.handle_data.social_account) &&
            // JSON.stringify(this.data.agreements_disclaimers) === JSON.stringify(this.get_old_data.handle_data.agreements_disclaimers)
            
            return  this.type ==='create'|| !(
                JSON.stringify(this.data) === JSON.stringify(this.data_old) &&
                JSON.stringify(this.get_old_data.old) === JSON.stringify(this.get_old_data.new)
            );
        },
        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },
    },

    components: {
        ProgramForm,
        FormFormRight,
        Loading,
        Modal,
        Button,
        ApplicationPublishModal,
    },
    
    methods: {
        getFormApiData:getFormApiData,

        //儲存與更新
        handleOldData(val){

            if(val.tip==='old'){ //只有progfram getData()(剛進入頁面會CALL的)才會有old的值
                this.get_old_data.old=JSON.parse(JSON.stringify(val.block));
                this.get_old_data.new=JSON.parse(JSON.stringify(val.block));
                this.data_old=JSON.parse(JSON.stringify(val.handle_data));
                this.data=JSON.parse(JSON.stringify(val.handle_data));
            }else{
                this.get_old_data.new=JSON.parse(JSON.stringify(val.block));
                this.data_old=JSON.parse(JSON.stringify(val.handle_data));
                //特殊處理(如果Social Accounts，右邊的Follower count顯示要處理)
                let block_open = val.block.find(item => item.field === 'social_account')?.is_add;
                checkSocial(val.handle_data.social_account, this.data.settings, block_open);
            }
        


        },

        //儲存完會重新CALL一次
        async getData() {

            this.is_loading=true;
            let field=this.type==='create'?'application_template_id':'ambassador_application_id'
            let id=this.type==='create'?this.porgram_for_who:this.porgram_id;
            let api = `${this.get_form_data_api}?${field}=${id}`;

            try {
                const res = await this.$ajax(api, { method: 'get' });
                console.log('res.data.data-->', res.data.data);
                this.data = getFormApiData(res.data.data, this);
                this.has_unpublished_changes=res.data.data.has_unpublished_changes;

                //---------------------------------
                //create
                //---------------------------------
                if(this.type==='create'){
                    let tit_index = getIndex(this.data.basic, 'title', 'application_title');
                    this.data.basic[tit_index.i].question[tit_index.ii].client_view.val = this.get_data.application_title;

                    this.data.settings[0].section_groups[0].group_setting[0].input_value = this.get_data.application_title;
                    this.data.settings[0].section_groups[0].group_setting[1].input_value = this.get_data.application_url;
                    this.data.settings[0].section_groups[0].group_setting[2].input_value = this.get_data.create_tag;
                }else{
                    this.get_data.application_title=this.data.settings[0].section_groups[0].group_setting[0].input_value;
                }

                //-----------------------------------
                //edit
                //-----------------------------------
                if(this.data.application_template_id){
                    this.porgram_for_who=this.data.application_template_id;
                    this.application_status=this.data.application_status;
                }


                //-----------------------------------
                //重拿資料後要要看是否儲存過跟發布過
                //-----------------------------------
                if(this.call_api_btn.publish===true){
                    this.call_api_btn.is_change=false;//發布按鈕會看這個來判別是否要打開
                    this.call_api_btn.publish =false;//發布過了所以把狀態恢復成未發布
                }

                this.data_old=JSON.parse(JSON.stringify(this.data));
                this.is_loading=false;

            } catch (e) {
                console.log(e)
            }
        },

        async getTemplate() {
            let api = 'ambassador/get-application-template-list';

            try {
                const res = await this.$ajax(api, { method: 'get' });
                this.$store.state.program_data.form_ForCreatorList = [];
                res.data.data.forEach(e => {
                    e.text = e.ambassador_application_template_name;
                    e.type='application_template';
                    this.$store.state.program_data.form_ForCreatorList.push(e);
                });
               
            } catch (e) { }
        },

        //+++++++++++++++++++++++++++++++++++++++++
        //saveing
        //+++++++++++++++++++++++++++++++++++++++++
        updateRight(set) {
            this.data.settings = set.data;
            //this.checkResponseSetting();//目前不做setting檢查
            if(set.refrash_key){
                this.get_data.application_title=set.data[0].section_groups[0].group_setting[0].input_value;
                this.data.basic[0].question[0].client_view.val = set.data[0].section_groups[0].group_setting[0].input_value;
                this.key_refrash_left += 1;
            }

            if(set.rej_open!==null){
                let index = getIndex(this.data.basic, 'country_location', 'country_location');
                this.data.basic[index.i].is_required= set.rej_open? true : this.data.basic[index.i].is_required;
                this.data.basic[index.i].is_switch= set.rej_open? true : this.data.basic[index.i].is_switch;
                this.key_refrash_left_country += 1;
                
            }
        },

        updateLeft(val) {
            let value = val.val;
            if (val.field === 'title') {
                let index = getIndex(value, 'title', 'application_title');
                this.get_data.application_title=value[index.i].question[index.ii].client_view.val;
                this.data.settings[0].section_groups[0].group_setting[0].input_value = value[index.i].question[index.ii].client_view.val;
            }

            if(val.ambassador_application_template_id){
                this.porgram_for_who=val.ambassador_application_template_id;
                this.getData();
            }

            //吐回來才能檢查資料是否有更動
            if(val.field==='title' || val.field==='creator'){
                this.data.basic=val.val;
                //特殊處理(如果Country / Location沒打開並且必填，右邊的lacation不顯示)
                checkBasic(this.data.basic,this.data.settings);
                this.key_refrash_right+=1;
            }else{
                this.data[val.field]=JSON.parse(JSON.stringify(val.val));

                //特殊處理(如果Social Accounts，右邊的Follower count顯示要處理)
                if(val.field==='social_account'){
                    checkSocial(this.data.social_account, this.data.settings);
                    this.key_refrash_right+=1;
                }
            }

        },

        saveCallInside(){
            this.is_all_loading = true;
            this.$store.state.is_loading=true;
            this.is_save_call_in=true;
            this.$refs.formLeft.submit();
        },

        //檢查setting(打開general_settings的時間沒選目前要阻擋)
        checkResponseSetting () {
            let isV = false;  // 初始化標誌變數
            let mes=[];
            console.log('this.data',this.data)
            // 遍歷 this.data.settin,gs
            //目前setting要擋下的->打開日期但沒有填寫日期/打開age沒填age/打開Follower count沒填Follower count
            this.data.settings.forEach(setting => {
                // 找到 section_name 為 'general_settings' 的 section
                if (setting.section_name === 'general_settings') {
                    // 遍歷 section_groups
                    setting.section_groups.forEach(sectionGroup => {

                        if(sectionGroup.group_name==='application_period_start_date'){
                            sectionGroup.group_setting.forEach(set=>{
                                if(set.label==='application_start_date' || set.label==='application_deadline'){
                                    if(set.client_view.show && (!set.client_view.val || set.client_view.val === 'Invalid date' ) ){
                                        isV = true;
                                        mes.push('Settings > General Settings > Application period (UTC)')
                                    }
                                }
                            })
                        };
                    });
                }

                //---------------------------------------------
                //response_setting
                //---------------------------------------------
                if (setting.section_name === 'response_setting') {
                    // 遍歷 section_groups
                    setting.section_groups.forEach(sectionGroup => {

                        // 檢查 is_switch 是否為 true
                        if (sectionGroup.is_switch) {
                            // 遍歷 group_setting
                            sectionGroup.group_setting.forEach(groupSetting => {

                                // 檢查是否有 date 欄位
                                if ( groupSetting.client_view && groupSetting.client_view.name === 'Send Mode') {
                                    // 檢查 client_view.val 是否有值
                                    if (!groupSetting.client_view || groupSetting.client_view.val ==='scheduled') {
                                        // 檢查是否需要date(目前放最後一個，但這部分可能要在改(改位子就會壞掉))
                                        let value=sectionGroup.group_setting[ sectionGroup.group_setting.length-1 ].client_view.val;
                                       if(!value || value==='Invalid date'){                                     
                                            sectionGroup.group_setting[ sectionGroup.group_setting.length-1 ].client_view.err = true;
                                            isV = true;  // 如果有任一 err 出現，設置 isV 為 true
                                            mes.push(`Settings > Response Settings > ${sectionGroup.name}`)
                                       }else if(value){
                                            sectionGroup.group_setting[ sectionGroup.group_setting.length-1 ].client_view.err = false;
                                       }
                                    }
                                };
                            });
                        }
                    });
                }

                //---------------------------------------------
                //auto_rejection
                //---------------------------------------------
                if(setting.section_name === 'auto_rejection'){
                    setting.section_groups.forEach(sectionGroup => {

                        if(sectionGroup.group_name==='auto_rejection_age'){
                            let age_val= sectionGroup.group_setting[0].client_view.val;
  
                            if(sectionGroup.is_switch && (!age_val || (Array.isArray(age_val) && age_val.length === 0))){
                                isV = true;
                                mes.push('Settings > Auto-Rejection > Age');
                                sectionGroup.error_msg='Required';
                                sectionGroup.group_setting[0].client_view.err=true;
                            }
                        };

                        if(sectionGroup.group_name==='auto_rejection_location'){
                            let loc_val= sectionGroup.group_setting[0].client_view.val;

                            if(sectionGroup.is_switch && (!loc_val || (Array.isArray(loc_val) && loc_val.length === 0))){
                                isV = true;
                                mes.push('Settings > Auto-Rejection > Location');
                                sectionGroup.error_msg='Required';
                                sectionGroup.group_setting[0].client_view.err=true;
                            }
                        }

                        if(sectionGroup.group_name==='auto_rejection_social_follower_count' && sectionGroup.is_switch){
                            sectionGroup.group_setting.forEach((set, index)=>{
  
                                if(set.client_view){
                                    if(index===0){
                                        let tkS=this.data.social_account[1];
                                        if(tkS.can_edit && tkS.question[0].show && !set.client_view.val && set.label==='auto_rejection_social_follower_count_tiktok_min'){
                                            isV = true;
                                            mes.push('Settings > Auto-Rejection > TikTok follower count');
                                            set.client_view.error_msg='Required';
                                            set.client_view.err=true;
                                        }     
                                    }

                                if(index===1){
                                    let igS=this.data.social_account[2];                               
                                    if(igS.can_edit && igS.question[0].show && !set.client_view.val  && set.label==='auto_rejection_social_follower_count_instagram_min'){
                                        isV = true;
                                        mes.push('Settings > Auto-Rejection > Instagram follower count');
                                        set.client_view.error_msg='Required';
                                        set.client_view.err=true;
                                    
                                    }
                                }

                                    
                                }
                                
                            })
                        }
                    });
                }

            });
            return {val:isV,mes:mes};
        },

        saveAllSetting(value) {

            this.is_all_loading = true;
            this.$store.state.is_loading=true;
            let setting_had_err=this.checkResponseSetting();
            this.is_show_alert_modal=false;

            //檢查表單狀態(因為失敗的話,按下發布的按鈕不可以真的轉發布)
            //要注意現在如果要發布會需要CALL2-3隻API，除了儲存之外要多CALL純粹發布的API，並檢查Accept applications是否關上，如果關上了要再另外CALL一隻API
            let temp_status=this.handleClickPublish();
            let application_status= temp_status ? temp_status  : this.type ==='create'? "draft": temp_status;//active/draft/closed;
            //判定是否有按下重新發布
            let is_republish = this.application_status==='closed' && this.is_click_publish;
            let tmep_application_status=this.data.settings[0].section_groups[1].group_setting[2].client_view.show;

            //確認是否CALL API,草稿階段不做任何阻擋
            if((!setting_had_err.val && !value.hadErr) || (application_status ==='draft' && !this.is_click_publish)){
                this.$store.state.is_loading=true;
                const handleToBack=(val)=>{
                        let filtArr=value.data[val].filter(e=>{return e.can_edit});
                        return filtArr.map(e=>{
                            return {
                                ...e,
                                show:e.is_switch,//status
                                question:e.question.map((ee,k)=>{
                                    //9140#9 add
                                    //Parent-Introduction要另外處理
                                    let input_value= ee.client_view && ee.client_view.val ? ee.client_view.val : ee.val ? ee.val:'';
                                    
                                    if(ee.label==='parent_guardian_introduction' && ee.is_switch ){
                                        input_value= input_value?input_value: item.client_view.plac;
                                    }

                                    return{
                                        //第0個都會跟著父曾的值走，在programForm.vue也先動作過，這邊是保險再做一次
                                        is_question_required:  k===0? e.is_required : ee.client_view && ee.client_view.is_required !==undefined ? ee.client_view.is_required : e.is_required,
                                        label: ee.label,
                                        label_type: ee.label_type,
                                        input_value: input_value,
                                        show: ee.client_view && ee.client_view.show!== undefined ? ee.client_view.show : ee.show !== undefined ? ee.show: e.is_switch,//status
                                    }
                                })
                            }
                        })
                };
                //setting在另一邊
                const handleToBackSetting=()=>{
                    let settings_data=this.data.settings.filter(e=>{ return !e.not_use });
                    return settings_data.map(e=>{
                        let filterSectionGroup=e.section_groups.filter(ee=>{ return !ee.not_use });
                        return{
                            ...e,
                            section_groups:filterSectionGroup.map(ee=>{
                                return{
                                    ...ee,
                                    group_setting:ee.group_setting.map(item=>{

                                        //handle input_value
                                        let input_value='';
                                        //多選的input_value要另外處理
                                        if(item.input_type==='multi_select'){
                                            if(item.client_view && item.client_view.val){

                                                if(item.input_type==='multi_select'){
                                                    input_value=[];
                                                    item.client_view.val.forEach(value=>{
                                                        input_value.push(value.text);
                                                    })
                                                }else{
                                                    input_value=item.client_view.val;
                                                }

                                            }else if(item.input_value){
                                                input_value=item.input_value;
                                            }
                                        }else{
                                            if(item.input_value && item.tag ==='only_input_value'){
                                                input_value=item.input_value;
                                            }else if(item.client_view && item.client_view.val){
                                                input_value=item.client_view.val;
                                            }
                                        }

                                        //信箱另外處理
                                        if(item.is_need_default || ( item.is_email && ee.is_switch) ){
                                            input_value=input_value?input_value: item.client_view.plac;
                                        }

                                        //日期如果打開但沒填日期要重新關上
                                        // if(item.label==='application_start_date' || item.label==='application_deadline' ){
                                        //     input_value=input_value?input_value: item.client_view.plac;
                                        // }
                                        //-------------------------------------------

                                        return{
                                            label: item.label,
                                            label_type: item.label_type,
                                            show: item.client_view && item.client_view.show === false || ee.is_switch === false ? false: true,
                                            input_value:input_value,
                                        }
                                    }),
                                    show:ee.is_switch === false ? ee.is_switch: true,
                                }
                            })
                        }
                    });
                };

                //如果是草稿階段或關閉狀態按下發布按鈕，application_status不管開啟打開都要強制打開
                if(this.is_click_publish && (this.application_status==='draft' || this.application_status==='closed')){
                    this.data.settings[0].section_groups[1].group_setting[2].client_view.show=true;
                }

                let agreObj= handleToBack('agreements_disclaimers');
                agreObj.forEach((e, k) => {
                    if (k === 0) { 
                        e.question = e.question.filter(item => item.label !== 'anchor_term' && item.label !== 'sephora_term');
                    }
                });

                let for_bake_data={
                    application_tag: this.data.settings[0].section_groups[0].group_setting[2].input_value,
                    application_status: application_status,//active/draft/closed
                    application_logo_url:this.data.preview_logo_image_url,
                    basic:handleToBack('basic'),
                    social_account:handleToBack('social_account'),
                    parent_guardian_consent:handleToBack('parent_guardian_consent'),
                    agreements_disclaimers:agreObj,
                    custom_question:value.data.custom_question.map(e=>{
                        return{
                            ...e.client_view,
                            input_option: e.client_view.input_option.map(ee=>{return ee.name}),
                            input_type_id:e.id,
                            custom_question_id:e.is_new ? -1:e.cus_id
                        }
                    }),
                    //The structure is different from others
                    settings:handleToBackSetting(),
                }

                if(this.type === 'edit'){
                    for_bake_data.application_id=this.porgram_id;
                }else{
                    for_bake_data.application_template_id=this.porgram_for_who;
                }

                // console.log('for_bake_data',for_bake_data);
                let api=this.type==='create'?`/ambassador/create-application`:`/ambassador/update-application`;

                this.$ajax( api, {
                    method: 'post',
                    data: for_bake_data,
                }).then(res => {
                    this.is_copy=false;//存過一次就不再是複製
                    this.is_first_create=false;
                    this.get_form_data_api=`ambassador/get-application-data`;
                    this.porgram_id=res.data.data.ambassador_application_id;
                    
                    //如果是發布要順便發布
                    this.handleIfPublish(is_republish,tmep_application_status,res);

                }).catch(err=>{
                    HandleErrFunction(err,this);
                    console.log(err)
                    this.is_click_publish=false;
                    this.$store.state.is_loading=false;
                    this.is_all_loading = false;
                });
            }
            //前端攔截錯誤訊息要處理
            else{
                this.is_click_publish=false;
                this.err_box=[];
                if(value.err_mes.length>0){
                    this.err_box=value.err_mes;
                }

                if(setting_had_err.val){
                    this.err_box=[...this.err_box, ...setting_had_err.mes];
                }
                
                this.is_show_unp_modal=true;
                this.$store.state.is_loading=false;
                this.is_all_loading = false;
                //this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> ${err_mes}`);
            }
        },

        handleIfPublish(is_republish, tmep_application_status, res){
            let promises = [];
            let oneAlert=false;
            this.call_api_btn.is_change=true;//紀錄紀錄曾經變過

            // 檢查是否需要發布
            if (this.is_click_publish && !is_republish) {
                promises.push(
                    this.$ajax("/ambassador/publish-application", {
                        method: 'post',
                        data: { application_id: this.porgram_id },
                    }).then(() => {
                        // 成功後的操作，顯示模態窗口
                        if(this.application_status !=='draft'){         
                            this.notAlert(' Application updated.');
                        }else{
                            this.notAlert(' Application created.');
                        }
                        oneAlert=true;
                        this.call_api_btn.publish=true;//紀錄有發布成功
                    }).catch(e=>{
                        //發布失敗要把本來強制轉換的狀態恢復
                        if(tmep_application_status!==undefined){
                            this.data.settings[0].section_groups[1].group_setting[2].client_view.show=tmep_application_status;
                        }
                        this.call_api_btn.publish=false;
                    })
                );
            }else{
                this.call_api_btn.publish=false;
            }

            if(is_republish){
                this.data.settings[0].section_groups[1].group_setting[2].client_view.show=true;
            }
 
            // 檢查 client_view.show 是否為 false，需要額外呼叫 API(要發布狀況才CALL)
            // 這邊如果為false就會強制關起來(所以內裡表單根外裡表單會一樣...)
            if (!this.data.settings[0].section_groups[1].group_setting[2].client_view.show && (this.application_status==='active'||this.application_status==='scheduled')) {
                promises.push(
                    this.$ajax("/ambassador/close-application", {
                        method: 'post',
                        data: { application_id: this.porgram_id },
                    })
                );
            }
            //只有要發布的狀況才會CALL這個，普通存檔打開不會CALL(所以內裡表單的狀態會跟外層的表單狀態不一樣)
            else if( is_republish && this.application_status==='closed'){
                promises.push(
                    this.$ajax("/ambassador/republish-application", {
                        method: 'post',
                        data: { application_id: this.porgram_id },
                    }).catch(e=>{
                        //發布失敗要把本來強制轉換的狀態恢復
                        this.data.settings[0].section_groups[1].group_setting[2].client_view.show=tmep_application_status;
                    })
                );
            }

            // 等待所有的 promises 完成後再執行後續操作
            Promise.all(promises)
                .then(() => {

                    // 建立的話要重整畫面到編輯頁面
                    if(this.type==='create'){
                        this.is_show_alert_modal=false;
                        this.is_saving=true;
                        this.is_leave=true;
            
                        if (this.is_click_publish) {
                            window.localStorage.setItem('ANCHOR_show_pub_modal', true);
                        }
                        
                        window.location.href = `/programs/application/edit/${res.data.data.ambassador_application_id}`;
                        return
                    }

                    if (this.application_status ==='draft' && this.is_click_publish) {
                        // this.is_show_pub_modal=true;
                        this.$refs.pub_modal.open();
                    }

                    //如果成功上去後
                    if(this.is_click_window){
                        this.openClose();
                        this.is_click_window=false;
                        return
                    }

                    this.is_click_publish = false;
                    this.getData();
                    this.$store.state.is_loading=false;
                    this.is_all_loading = false;
                })
                .catch((err) => {
                    // 錯誤處理
                    console.log(err)
                    HandleErrFunction(err, this);
                    this.$store.state.is_loading=false;
                    this.is_all_loading = false;
                });

            // 处理非发布情况下的逻辑
            if (!this.is_click_publish) {
                if(!oneAlert){
                    this.notAlert(' Application saved.')
                }
                
                if (!this.will_close_setting && Promise.length === 0) {
                    this.getData();
                }
            }

            // 處理表單關閉邏輯
            if (this.will_close_setting) {
                this.openClose();
            }

        },

        notAlert(val){
            this.$notify({
                group: 'white',
                text: `<svg><use xlink:href="#yes--sprite"></use></svg> ${val}`,
                type: 'success', 
            });
        },

        //+++++++++++++++++++++++++++++++++++++++++
        //button 點下去要做判定
        //+++++++++++++++++++++++++++++++++++++++++
        onlyClose(){
            if(this.is_can_save){
                this.is_show_alert_modal = true;
            }else{
                this.$store.state.is_loading=true;
                this.openClose();
            }
        },

        publish() {
            this.is_click_publish=true;//handle住，API成功才執行
            this.$store.state.is_loading=true;
            //傳進去撈設定好的資訊會再回來呼叫saveAllSetting();
            this.saveCallInside();
        },


        handleClickPublish(){
            if(this.is_click_publish){
                //active/draft/closed
                return 'active';
            }else{
                return this.application_status?this.application_status:'draft';
            }
        },

        onlyView() {
            this.is_only_for_view = true;
        },

        closeOnlyForView(){
            this.is_only_for_view=false;
            if(this.from_list_handle_for_view){
                this.openClose()
            }
        },

        //目前沒有複製表單所以也沒有使用
        // checkName(name, data) {
        //     // 使用正則表達式來檢查名稱是否有數字後綴
        //     const namePattern = /^(.*?)(\((\d+)\))?$/;
        //     let match = namePattern.exec(name);
        //     let baseName = match[1];
        //     let suffix = match[3] ? parseInt(match[3], 10) : 1;

        //     // 找到最大數字後綴
        //     data.forEach(item => {
        //         let itemMatch = namePattern.exec(item.title);
        //         if (itemMatch && itemMatch[1] === baseName && itemMatch[3]) {
        //             let itemSuffix = parseInt(itemMatch[3], 10);
        //             if (itemSuffix >= suffix) {
        //                 suffix = itemSuffix + 1;
        //             }
        //         }
        //     });

        //     // 確保新的名稱是唯一的
        //     while (data.some(item => item.title === `${baseName}(${suffix})`)) {
        //         suffix++;
        //     }

        //     return `${baseName}(${suffix})`;
        // },

        //目前沒有複製表單所以也沒有使用
        checkUrl(url,data) {
            let suffix = 1;

            while (data.some(item => item.url.split('/p/')[1] === url)) {
                url = `${url}-${suffix}`;
                suffix++;
            }

            return url;
        },

        delPro(){

            if(this.type==='create'){
                this.openClose();
                this.is_show_del_modal=false;
                this.notAlert(' Application deleted.')
            }else{
                this.$store.state.is_loading=true;
                this.$ajax(`/ambassador/delete-application`, {
                    method: 'post',
                    data:{
                        application_id:this.porgram_id,
                    },
                }).then(res => {
                    
                    this.notAlert(' Application deleted.')
                    this.is_saving=true;
                    window.location.href =`/programs/applications-list`
                    this.$store.state.is_loading=false;
                }).catch(err=>{
                    HandleErrFunction(err,this);
                    this.$store.state.is_loading=false;
                });
            }   
        },

        // copy(link) {
        //     copyToClipboard(link, {format:'text/plain'});
        //     this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Link copied`);
        // },

        // goView(link){
        //     window.open(link, '_blank');
        //     this.is_show_pub_modal=false;
        // },

        openClose(){
            this.$store.state.is_loading=true;
            this.$store.state.program_data.type='';
            this.$store.state.program_data.create_data=null;
            this.$store.state.program_data.id=1;
            this.$store.state.program_data.is_preview= false;
            this.is_saving=true;
            this.is_leave=true;
            if(this.is_key_ref){
                console.log(this.is_leave);
                this.$router.go(0);
            }else{
                if(document.referrer && document.referrer.includes('programs/application/create')){
                    window.location.href =`/programs/applications-list`
                }else{
                    window.history.go(-1)
                }
            }
        },

        handleGoLive(){
            if (window.localStorage.getItem('ANCHOR_show_pub_modal')) {
                // this.is_show_pub_modal=true;
                this.$refs.pub_modal.open();
                window.localStorage.removeItem('ANCHOR_show_pub_modal');
            }
        },

        //重整catch
        handleBeforeUnload(event) {
            try {
                
                if (!this.is_leave && this.is_can_save ) {
                    event.preventDefault(); 
                    event.returnValue = ''; 
                    return '';
                }
            } catch (error) {
                console.error('Error in handleBeforeUnload:', error);
            }
        },
    },

    beforeRouteLeave(to, from, next) {
        // 回上一页
        if(this.is_can_save){
            if(!this.is_show_alert_modal && !this.is_saving){

                this.is_click_window=true;
                next(false);//強行阻止往返上一頁
                this.is_show_alert_modal=true;
                
            }else{
                this.is_leave=true;
                next();
                this.is_show_alert_modal=false;
            }
        }else{

            this.is_leave=true;
            next();
            if (this.$route.params && this.type ==='create' ) {
                window.location.href =`/programs/applications-list`
            }
        }
    },

    async mounted() {
        if(!this.permission_recruitment.manageApplications.permission || !this.permission_recruitment.editApplicationSettings.permission){
            this.$router.push({ name: 'creator--list' });
            return;
        }
        let item=this.$store.state.program_data;
        let rou=this.$route.params;
        this.originalURL = this.$route.fullPath;
        const path = this.$route.path; // ex "/programs/application/create/1"
        const parts = path.split('/'); 
        const action = parts[3]; 
        this.type= action;
        this.is_all_loading = true; 

        if(item.create_data){
            this.get_data=item.create_data;
        }

        if(this.type==='create'){
            this.get_form_data_api=`ambassador/get-application-template`;
            this.is_first_create=true;
            this.porgram_id=null;
            if(!this.get_data.application_title){
                let da=JSON.parse(window.localStorage.getItem('ANCHOR_program_create_data'));
                if(!da){
                    this.openClose();
                }else{
                    this.get_data=da;
                }
            }

        }else if(this.type==='edit'){
            this.get_form_data_api=`ambassador/get-application-data`;
            this.porgram_id=rou.application_id;
        }



        await this.getTemplate();
        await this.getData();
        this.handleGoLive();

        this.is_all_loading = false;
        this.$store.state.is_loading = false;

        //----------------------------------------------
        //item.act=>preview/forPublish/copy
        //----------------------------------------------
        if(item.is_preview){
            this.onlyView();
            this.from_list_handle_for_view=true;
        }

        //複製要先取得edit再把type轉回create(現在沒用)
        // else if(item.act==='copy'){
        //     this.type='create';
        //     this.is_copy=true;
            
        //     let tit_index = getIndex(this.data.basic, 'title', 'application_title');
        //     let hdata=this.data.settings[0].section_groups[0];
        //     const _ = require('lodash');
        //     let newName=this.checkName(hdata.group_setting[0].input_value,item.list);
        //     this.data.basic[tit_index.i].question[tit_index.ii].client_view.val = newName;

        //     this.data.settings[0].section_groups[0].group_setting[0].input_value = newName;
        //     this.data.settings[0].section_groups[0].group_setting[1].input_value = this.checkUrl(_.kebabCase(newName),item.list);
        // }

        //});
    },

    created() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        window.addEventListener('keydown', this.preventRefresh);
        
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        window.removeEventListener('keydown', this.preventRefresh);
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.pro-setting {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: var(--dark-blue);
    top: 0;
    left: 0;
    z-index: 4;

    .head {
        height: 48px;
        width: 100%;
        @include flexCenter();
        padding: 0 16px;

        .left {
            flex: 1;
            font: var(--font-med-14);
            color: var(--white);
            @include flexCenter();

            .svg-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
                fill: var(--white);
                cursor: pointer;
            }
        }

        .right {
            @include flexCenter();

            .desc {
                font-size: 12px;
                color: var(--black-40);
            }

            .ui-button {
                margin-left: 16px;

                &.unp-btn{
                    background-color: var(--black-10);
                    color: var(--black-40);
                }
            }

            .pre-btn {
                border: solid 1px var(--white);

                .svg-icon {
                    width: 14px;
                    height: 14px;
                }
            }

            .del-btn {
                border: solid 1px var(--red);
                background-color:var(--white);
                color:var(--red);
            }

        }
    }


}

.pro-setting-box {
    background-color: var(--dark-blue);
    display: grid;
    grid-template-columns: 1fr 320px;
    top: 0;

    .left-template {
        width: 100%;
    }

    .right-template {
        width: 100%;
        padding: 16px;
    }

    input,
    textarea {
        padding: 6px 8px;
        height: 36px;
        border: 1px solid var(--black-20);
        background-color: white;
        flex: 1;
        border-radius: 6px;
        color: var(--black-90);
        transition: .15s border-color ease;
        font-weight: 500;
        font-family: var(--font);

        &:hover {
            border-color: var(--black-50);
        }

        &:focus {
            outline: none;
            border-color: var(--dark-blue);
        }

        &::placeholder {
            color: var(--black-50);
            font-weight: 500;
            line-height: 18px;
        }
    }

    textarea {
        height: 120px;
    }
}

.modal-del-btn{
    background-color:var(--red) !important;
}

.un-pub-modal{
    .ui-modal--container {
        width: 330px;
    }

    .box {
        padding: 24px;
        header {
            font: var(--font-demi-20);
            color: var(--black-90);
            letter-spacing: 1px;
            margin-bottom: 8px;
        }

        p {
            font-size: 16px;
            color: var(--black-60);
        }

        .btns {
            @include flexCenter();
            justify-content: flex-end;
        }
    }

    ul li{
        list-style: disc !important;
        margin-left:24px;
    }

}

</style>